
/**
 * Animates scrolling to a point on the page, uses the data-scroll attribute rather than the ID attribute to determine
 * the scroll location as this avoids any interactions with the browser's built in hash scrolling.
 *
 * @param {string} hash
 * @param {string} child
 * @param {number} offset
 * @param {number} speed
 * @returns {boolean}
 * @constructor
 */
function scrollToHash(hash, child, offset, speed) {
    offset = offset || 0;
    speed = speed || 800;

    if(hash.indexOf('/') >= 0) {
        hash = hash.split('/', 1)[0];
    }

    hash = encodeURIComponent(hash.replace('#', ''));

    let element = $('[data-scroll="'+hash+'"]');

    if(child && $(element).find(child).length > 0) {
        element = $(element).find(child);
    }

    if($(element).length > 0) {
        if (!element.hasClass('recent-scroll')) {
            element.addClass('scroll-target').addClass('recent-scroll');
        }

        $('html, body').animate({
            scrollTop: (
                element.offset().top - offset
            )
        }, speed, 'swing', function() {
            setTimeout(function() {
                element.removeClass('scroll-target');
            }, 500);

            setTimeout(function() {
                element.removeClass('recent-scroll');
            }, 5000);
        });
        return true;
    }

    return false;
}

export function scrollTo(){
    $(window).on('hashchange', function (e) {

        if (location.hash) {
            if (!scrollToHash(location.hash, null, 0, 750)) {
                e.preventDefault();
            }
        }
    });

    $('a').on('click', function (e) {
        let $el = $(this);

        if ($el.attr('href') && $el.attr('href').search('#') === 0) {
            let hash = $el[0].hash;

            if (!scrollToHash(hash, null, 0, 750)) {
                e.preventDefault();
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollToHash.js